import { Provider } from "./provider"
import * as themes from "./themes"

export default {
  Provider,
  themes,
}
